import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export default styled(Typography)(({ theme }) => ({
  color: theme.palette.customGrey[900],
  letterSpacing: '-.02em',
  fontSize: '36px',
  fontWeight: 600,
  lineHeight: '44px',
  marginBottom: '32px'
}))
